import React from "react";
import { useTranslation } from "react-i18next";
import exclamationIcon from "../../../assets/icons/flash-message/exclamation.png";
import "./ErrorMessage.css";

const ErrorMessage = ({ message, onClose }) => {
  const { t } = useTranslation();

  if (!message) return null;
  return (
    <div className="error-message-card">
      <div className="error-message-icon">
        <img src={exclamationIcon} alt={t("common.errorAlt", "Error")} />
      </div>
      <span className="error-message-text">{message}</span>
      <button
        className="error-message-close"
        onClick={onClose}
        aria-label={t("common.closeError", "Close error")}
        type="button"
      >
        ×
      </button>
    </div>
  );
};

export default ErrorMessage;
